export default class EnvironmentUtils {
  private constructor() {}

  public static getStaffDomain() {
    return process.env.REACT_APP_STAFF_DOMAIN || "";
  }

  public static getApiUrl() {
    return process.env.REACT_APP_API_BASE || "";
  }

  public static getSentryEnabled() {
    return !!process.env.REACT_APP_SENTRY_ENABLED;
  }

  public static getSentryDsn() {
    return process.env.REACT_APP_SENTRY_DSN || "";
  }

  public static getSentryEnvironment() {
    return process.env.REACT_APP_SENTRY_ENVIRONMENT || "";
  }

  public static getSentryRelease() {
    return process.env.REACT_APP_SENTRY_RELEASE || "";
  }

  public static getSentryDebug() {
    return !!process.env.REACT_APP_SENTRY_DEBUG;
  }

  public static getGaTrackingCode() {
    return process.env.REACT_APP_GA_TRACKING_CODE || "";
  }

  public static getGaTestMode() {
    return !!process.env.REACT_APP_GA_TEST_MODE;
  }
}
